// extracted by mini-css-extract-plugin
export default {"titlePage":"user_titlePage__8wVem"};